import React, { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import './GettingStartedFAQs.css';
import { Link } from 'react-router-dom';
import faqsByTopic from '../FaqData/FaqData';

const FAQs = ({ topicKey }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const topicData = faqsByTopic[topicKey] || [];

  const toggleItem = (categoryIndex, itemIndex) => {
    const newIndex = `${categoryIndex}-${itemIndex}`;
    setActiveIndex(activeIndex === newIndex ? null : newIndex);
  };

  // 🔗 Replace text snippets with router <Link> components
  const transformText = (text) => {
    const mappings = [
      { phrase: 'contact us', route: '/contact' },
      { phrase: 'homepage', route: '/' }
    ];

    let parts = [text];
    mappings.forEach(({ phrase, route }) => {
      parts = parts.flatMap((part) => {
        if (typeof part === 'string' && part.toLowerCase().includes(phrase.toLowerCase())) {
          const regex = new RegExp(`(${phrase})`, 'i');
          const split = part.split(regex);
          return split.map((chunk, i) =>
            regex.test(chunk) ? (
              <Link to={route} className="faq-link" key={route + i}>
                {chunk}
              </Link>
            ) : (
              chunk
            )
          );
        }
        return part;
      });
    });

    return parts;
  };

  // 🔍 Parse answer and convert phrases to links
  const renderAnswer = (answer) => {
    const lines = answer.split('\n').map(line => line.trim());
    return (
      <div>
        {lines.map((line, i) => (
          <p key={i}>{transformText(line)}</p>
        ))}
      </div>
    );
  };

  return (
    <div className="faq-wrapper">
      <h1 className="faq-title">{topicKey.replace(/-/g, ' ').toUpperCase()}</h1>
      <div className="faq-columns">
        {topicData.map((section, categoryIndex) => (
          <div className="faq-category" key={categoryIndex}>
            <h2 className="faq-category-title">{section.category}</h2>
            {section.items.map((item, itemIndex) => {
              const index = `${categoryIndex}-${itemIndex}`;
              const isActive = activeIndex === index;
              return (
                <div
                  className={`faq-item ${isActive ? 'open' : ''}`}
                  key={index}
                  onClick={() => toggleItem(categoryIndex, itemIndex)}
                >
                  <div className="faq-question1">
                    {item.question}
                    <span className="faq-icon">
                      {isActive ? <FaMinus /> : <FaPlus />}
                    </span>
                  </div>
                  {isActive && (
                    <div className="faq-answer">
                      {renderAnswer(item.answer)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;
